import axios from 'axios';
import axiosInstance from './AxiosConfig';

export const fetchToken = async () => axiosInstance.get('/parcours/siren/token');

export const fetchSirenData = async raisonSociale =>
  await axios.get(`https://api.insee.fr/api-sirene/3.11/siret?q=denominationUniteLegale:${raisonSociale}`, {
    headers: {
      'X-INSEE-Api-Key-Integration': process.env.REACT_APP_SIREN_API_KEY,
      'Content-Type': 'application/json',
    },
  });
